import Base               from './components/Base'
import BatiFid            from './components/BatiFid'
import Loyalty            from './components/Loyalty'
import LoyaltyV3          from './components/LoyaltyV3'
import Dematerialisation  from './components/Dematerialisation'

export default Dematerialisation(LoyaltyV3(Loyalty(BatiFid(Base))))
